export default __webpack_public_path__ + "static/media/website.30c742f6.svg";